module.exports = {
    location: "Standorte",
    dispatching: "Versand"
}